import React from "react";
import "./style/SwitchButton.css";

const SwitchButton = ({ value, setValue }) => {
  const active = value === "allStates" ? "right" : "left";

  return (
    <div className="switch-container">
      <div className="switch-button">
        <div
          className={`switch-toggle switch-left ${active === "left" ? "active" : ""}`}
          onClick={() => setValue("myStates")}
        >
          MY STATES
        </div>
        <div
          className={`switch-toggle switch-right ${active === "right" ? "active" : ""}`}
          onClick={() => setValue("allStates")}
        >
          ALL STATES
        </div>
      </div>
    </div>
  );
};

export default SwitchButton;
